<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.VariantType"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  [scaleDownLinkedKey]="section?.id + ((section | isInLineMode) ? Types.TextSizeLink.VariantType : null)"
  class="section-header-general section-header-quantity-in-stock">
  {{ menu | productMenuBasicMethod: 'getVariantTypeColumnTitle' : colVm }}
</div>
